import { render } from "./UserRecruits.vue?vue&type=template&id=11e42370&scoped=true&lang=pug"
import script from "./UserRecruits.vue?vue&type=script&lang=js"
export * from "./UserRecruits.vue?vue&type=script&lang=js"

import "./UserRecruits.vue?vue&type=style&index=0&id=11e42370&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e42370"]])

export default __exports__